/**
 * PlaybookAgent — Phase A stub. Phase D will wire this up to summarize
 * uploaded playbook PDFs once storage is available.
 */

import type { AgentRunContext, AgentRunResult, CoachSteveAgent } from './types';

export const playbookAgent: CoachSteveAgent = {
  name: 'playbook',
  description:
    "Summarizes uploaded playbook PDFs. Stub for Phase D — currently disabled.",
  applicableSports: 'all',
  match: () => false,
  async handle(_text, ctx: AgentRunContext): Promise<AgentRunResult> {
    ctx.addMessage(
      'assistant',
      "Playbook uploads are coming soon. For now, please paste key plays into chat and I’ll work with you that way."
    );
    return { kind: 'handled' };
  },
};
